import { render } from "./AgentWhatsAppView.vue?vue&type=template&id=e4e44d52&scoped=true"
import script from "./AgentWhatsAppView.vue?vue&type=script&lang=js"
export * from "./AgentWhatsAppView.vue?vue&type=script&lang=js"

import "./AgentWhatsAppView.vue?vue&type=style&index=0&id=e4e44d52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4e44d52"]])

export default __exports__